import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractDateInput} from "../abstract-date-input";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterDateInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-date-input",
    styleUrls: ["./filter-date-input.component.scss"],
    templateUrl: "./filter-date-input.component.html",
    standalone: false
})
export class FUIFilterDateInputComponent extends FUIAbstractDateInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef,
                eventsService: FUIEventsService) {
        super(elementRef, changeDetectorRef, eventsService);
    }
}
